import React from 'react';
import { motion } from 'framer-motion';

/**
 * TextReveal Component
 * 
 * Crée un effet de texte dévoilé (reveal) lettre par lettre ou mot par mot.
 * Utilisé principalement pour les titres du hero.
 * 
 * Props:
 * - text: Le texte à afficher
 * - className: Classes CSS additionnelles
 * - delay: Délai avant le début de l'animation
 * - byWord: Si true, anime mot par mot, sinon lettre par lettre
 */
const TextReveal = ({ text, className = '', delay = 0, byWord = true }) => {
  const items = byWord ? text.split(' ') : text.split('');
  
  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: byWord ? 0.12 : 0.03,
        delayChildren: delay,
      },
    },
  };
  
  const child = {
    hidden: {
      opacity: 0,
      y: 50,
      rotateX: -90,
    },
    visible: {
      opacity: 1,
      y: 0,
      rotateX: 0,
      transition: {
        type: 'spring',
        damping: 20,
        stiffness: 100,
      },
    },
  };
  
  return (
    <motion.h1
      className={`${className} overflow-hidden`}
      variants={container}
      initial="hidden"
      animate="visible"
      style={{ perspective: '1000px' }}
    >
      {items.map((item, index) => (
        <motion.span
          key={index}
          variants={child}
          className="inline-block"
          style={{ 
            marginRight: byWord ? '0.3em' : '0',
            transformOrigin: 'center bottom',
          }}
        >
          {item}
        </motion.span>
      ))}
    </motion.h1>
  );
};

export default TextReveal;
